import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import 'firebase/compat/functions';
import 'firebase/compat/messaging';
import 'firebase/compat/storage';
/**
 * Firestore and the functions both live in europe-west6; the SDK would call
 * the us-central1 default and every request would cross the Atlantic twice.
 */
const FUNCTIONS_REGION = 'europe-west6';
const firebaseConfig = {
    apiKey: process.env.VUE_APP_API_KEY,
    authDomain: process.env.VUE_APP_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_DATABASE_URL,
    projectId: process.env.VUE_APP_PROJECT_ID,
    storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_APP_ID,
};
firebase.initializeApp(firebaseConfig);
export const functions = firebase.app().functions(FUNCTIONS_REGION);
// Connect to Firebase emulators when VUE_APP_USE_EMULATORS is set
if (process.env.VUE_APP_USE_EMULATORS === 'true') {
    firebase.auth().useEmulator('http://127.0.0.1:9099');
    firebase.firestore().useEmulator('127.0.0.1', 8085);
    functions.useEmulator('127.0.0.1', 5001);
    firebase.storage().useEmulator('127.0.0.1', 9199);
}
export const messaging = firebase.messaging.isSupported() ? firebase.messaging() : null;
export const database = firebase.firestore();
export default firebase;
